export const API_ROOT = "https://authenticator.webdeskinc.com/";

// all api end points
export const API_END_POINTS = {
  MERCHANT_STORE_SETTING: "api/v1/setting",
  MERCHANT_STORE_SETTING_UPDATE: "api/v1/setting",
  METCHANT_DESIGNS_SETTING: "/api/v1/setting/design",
  METCHANT_CUSTOME_DESIGNS: "/api/v1/setting/getCustomeDesigns",
  METCHANT_CUSTOME_DESIGNS_UPDATE: "/api/v1/setting/updateCustomeDesigns",

};

// all types mention

export const Types = {
  FETCH_SETTING: "FETCH_SETTING",
  UPDATE_SETTING: "UPDATE_SETTING",

};
